module.exports = __webpack_public_path__ + "img/qx_icon2.a88cb638.png";